const fadeInClassName = (isInView = false) =>
  `${
    isInView ? "opacity-100" : "opacity-0"
  } transition-opacity duration-300 ease-in-out`;

export default fadeInClassName;
